export const waLink = (number, text) =>
  `https://wa.me/${number}?text=${encodeURIComponent(text)}`;

export const orderWaMessage = (order, formatRupiah) =>
  [
    `Halo Puspita Florist, saya sudah melakukan pemesanan.`,
    `Kode Pesanan: ${order.order_code}`,
    `Nama: ${order.buyer_name}`,
    `Total: ${formatRupiah(order.total)}`,
    ``,
    `Mohon dicek statusnya. Terima kasih.`,
  ].join("\n");

export const statusWaMessage = (code) =>
  `Halo Puspita Florist, saya ingin cek status pesanan${code ? ` dengan kode ${code}` : ""}.`;
